(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~popover"],{

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _tooltip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34);
/* harmony import */ var _tooltip_abstractTooltipProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70);
/* harmony import */ var utils_vue_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var utils_props_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1);
/* harmony import */ var base_config_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8);
/* harmony import */ var directives__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var props = Object(_tooltip_abstractTooltipProps__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])();
var Popover = {
  name: 'MegPopover',
  props: _objectSpread(_objectSpread({}, props), {}, {
    prefixCls: utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].string,
    content: utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].any,
    title: utils_vue_types__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].any
  }),
  model: {
    prop: 'visible',
    event: 'visibleChange'
  },
  inject: {
    configProvider: {
      default: function _default() {
        return base_config_provider__WEBPACK_IMPORTED_MODULE_4__["ConfigConsumerProps"];
      }
    }
  },
  methods: {
    getPopupDomNode: function getPopupDomNode() {
      return this.$refs.tooltip.getPopupDomNode();
    }
  },
  render: function render() {
    var h = arguments[0];
    var title = this.title,
        customizePrefixCls = this.prefixCls,
        $slots = this.$slots;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('popover', customizePrefixCls);
    var props = Object(utils_props_util__WEBPACK_IMPORTED_MODULE_3__["getOptionProps"])(this);
    delete props.title;
    delete props.content;
    var tooltipProps = {
      props: _objectSpread(_objectSpread({}, props), {}, {
        prefixCls: prefixCls
      }),
      ref: 'tooltip',
      on: Object(utils_props_util__WEBPACK_IMPORTED_MODULE_3__["getListeners"])(this)
    };
    return h(_tooltip__WEBPACK_IMPORTED_MODULE_0__["default"], tooltipProps, [h("template", {
      slot: "title"
    }, [h("div", [(title || $slots.title) && h("div", {
      "class": "".concat(prefixCls, "-title")
    }, [Object(utils_props_util__WEBPACK_IMPORTED_MODULE_3__["getComponentFromProp"])(this, 'title')]), h("div", {
      "class": "".concat(prefixCls, "-inner-content")
    }, [Object(utils_props_util__WEBPACK_IMPORTED_MODULE_3__["getComponentFromProp"])(this, 'content')])])]), this.$slots.default]);
  }
};
/* istanbul ignore next */

Popover.install = function (Vue) {
  // Vue.use(Base);
  Vue.use(directives__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"]);
  Vue.component(Popover.name, Popover);
};

/* harmony default export */ __webpack_exports__["default"] = (Popover);

/***/ })

}]);